const initialState = {
    //country state city port
    loadingFFSECountry: false,
    FFSECountry: [],
    FFSECountryError: "",
    loadingFFSEState: false,
    FFSEState: [],
    FFSEStateError: "",
    loadingFFSECity: false,
    FFSECity: [],
    FFSECityError: "",
    loadingFFSESeaport: false,
    FFSESeaport: [],
    FFSESeaportError: "",



    //job order info 
    loadingFFQueryDetail: false,
    FFQueryDetailError: "",
    FFQueryDetail: {},
    //job order List 
    loadingFFSeaExpJobOrderList: false,
    FFSeaExpJobOrderListError: "",
    FFSeaExpJobOrderList: [],

    //currency List 
    loadingFFSeaExpCurrencyList: false,
    FFSeaExpCurrencyListError: "",
    FFSeaExpCurrencyList: [],

    //final Quotation
    loadingFFSeaExpFinalQuotationList: false,
    FFSeaExpFinalQuotationListError: "",
    FFSeaExpFinalQuotationList: [],

    //currency List 
    loadingFFSeaExpAirportList: false,
    FFSeaExpAirportListError: "",
    FFSeaExpAirportList: [],


    //organisation list
    loadingFFSeaExpOrganisationList: false,
    FFSeaExpOrganisationList: [],
    FFSeaExpOrganisationListError: '',

    //organisation shipper branch list
    loadingFFSeaExpShipperBranchList: false,
    FFSeaExpShipperBranchList: [],
    FFSeaExpShipperBranchListError: '',

    //organisation consignee branch list
    loadingFFSeaExpConsigneeBranchList: false,
    FFSeaExpConsigneeBranchList: [],
    FFSeaExpConsigneeBranchListError: '',

    //organisatoin shipper branch bank list
    loadingFFSeaExpShipperBranchBankList: false,
    FFSeaExpShipperBranchBankList: [],
    FFSeaExpShipperBranchBankListError: '',

    //organisatoin consignee branch bank list
    loadingFFSeaExpConsigneeBranchBankList: false,
    FFSeaExpConsigneeBranchBankList: [],
    FFSeaExpConsigneeBranchBankListError: '',

    //hawb details
    loadingFFSeaExpHBLDetail: false,
    FFSeaExpHBLDetail: [],
    FFSeaExpHBLDetailError: '',

    //direct mawb details
    loadingFFSeaExpDirectMAWBDetail: false,
    FFSeaExpDirectMAWBDetail: [],
    FFSeaExpDirectMAWBDetailError: '',

    //mawb details
    loadingFFSeaExpMAWBDetail: false,
    FFSeaExpMAWBDetail: [],
    FFSeaExpMAWBDetailError: '',

    //unused hawb list
    loadingFFSeaExpUnusedHBLList: false,
    FFSeaExpUnusedHBLList: [],
    FFSeaExpUnusedHBLListError: '',

    //unused hawb update list
    loadingFFSeaExpUnusedHAWBUpdateList: false,
    FFSeaExpUnusedHAWBUpdateList: [],
    FFSeaExpUnusedHAWBUpdateListError: '',


    //ff-> air-> exp -> console shipment list
    loadingFFSeaExpConsoleShipmentList: false,
    FFSeaExpConsoleShipmentList: [],
    FFSeaExpConsoleShipmentListError: '',
    FFSeaExpConsoleShipmentListCurrentPage: 0,
    FFSeaExpConsoleShipmentListTotalPage: 0,
    FFSeaExpConsoleShipmentListTotalData: 0,
    // FFSeaExpConsoleShipmentListCount: {},

    //ff-> air-> exp -> direct shipment list
    loadingFFSeaExpDirectShipmentList: false,
    FFSeaExpDirectShipmentList: [],
    FFSeaExpDirectShipmentListError: '',
    FFSeaExpDirectShipmentListCurrentPage: 0,
    FFSeaExpDirectShipmentListTotalPage: 0,
    FFSeaExpDirectShipmentListTotalData: 0,
    // FFSeaExpDirectShipmentListCount: {},

    //ff-> air-> exp -> console Manifest list
    loadingFFSeaExpConsoleManifestList: false,
    FFSeaExpConsoleManifestList: [],
    FFSeaExpConsoleManifestListError: '',
    FFSeaExpConsoleManifestListCurrentPage: 0,
    FFSeaExpConsoleManifestListTotalPage: 0,
    FFSeaExpConsoleManifestListTotalData: 0,
    // FFSeaExpConsoleManifestListCount: {},

    //mawb => total freight calculation
    loadingFFSeaExpTotalFreight: false,
    FFSeaExpTotalFreight: {},
    FFSeaExpTotalFreightError: '',

}

const FFSeaExpReducer = (state = initialState, action) => {
    switch (action.type) {

        //country state city port List//
        case 'FIND_FF_SE_COUNTRY_REQUEST':
            return {
                ...state,
                loadingFFSECountry: true,
                FFSECountry: [],
                FFSECountryError: '',
            };
        case 'FIND_FF_SE_COUNTRY_SUCCESS':
            return {
                ...state,
                loadingFFSECountry: false,
                FFSECountry: action.payload,
            };
        case 'FIND_FF_SE_COUNTRY_FAILURE':
            return {
                ...state,
                loadingFFSECountry: false,
                FFSECountryError: action.payload,
            };
        case 'FIND_FF_SE_STATE_REQUEST':
            return {
                ...state,
                loadingFFSEState: true,
                FFSEState: [],
                FFSEStateError: '',
            };
        case 'FIND_FF_SE_STATE_SUCCESS':
            return {
                ...state,
                loadingFFSEState: false,
                FFSEState: action.payload,
            };
        case 'FIND_FF_SE_STATE_FAILURE':
            return {
                ...state,
                loadingFFSEState: false,
                FFSEStateError: action.payload,
            };
        case 'FIND_FF_SE_CITY_REQUEST':
            return {
                ...state,
                loadingFFSECity: true,
                FFSECity: [],
                FFSECityError: '',
            };
        case 'FIND_FF_SE_CITY_SUCCESS':
            return {
                ...state,
                loadingFFSECity: false,
                FFSECity: action.payload,
            };
        case 'FIND_FF_SE_CITY_FAILURE':
            return {
                ...state,
                loadingFFSECity: false,
                FFSECityError: action.payload,
            };
        case 'FIND_FF_SE_SEAPORT_REQUEST':
            return {
                ...state,
                loadingFFSESeaport: true,
                FFSESeaport: [],
                FFSESeaportError: '',
            };
        case 'FIND_FF_SE_SEAPORT_SUCCESS':
            return {
                ...state,
                loadingFFSESeaport: false,
                FFSESeaport: action.payload,
            };
        case 'FIND_FF_SE_SEAPORT_FAILURE':
            return {
                ...state,
                loadingFFSESeaport: false,
                FFSESeaportError: action.payload,
            };
        //country state city port List//

        //query info List//
        case 'FIND_FF_QUERY_INFO_REQUEST':
            return {
                ...state,
                loadingFFQueryDetail: true,
                FFQueryDetail: {},
                FFQueryDetailError: '',
            };
        case 'FIND_FF_QUERY_INFO_SUCCESS':
            return {
                ...state,
                loadingFFQueryDetail: false,
                FFQueryDetail: action.payload,
            };
        case 'FIND_FF_QUERY_INFO_FAILURE':
            return {
                ...state,
                loadingFFQueryDetail: false,
                FFQueryDetailError: action.payload,
            };
        //query info List//

        //job order List//
        case 'FIND_FF_SEA_EXP_JOBORDER_REQUEST':
            return {
                ...state,
                loadingFFSeaExpJobOrderList: true,
                FFSeaExpJobOrderList: [],
                FFSeaExpJobOrderListError: '',
            };
        case 'FIND_FF_SEA_EXP_JOBORDER_SUCCESS':
            return {
                ...state,
                loadingFFSeaExpJobOrderList: false,
                FFSeaExpJobOrderList: action.payload,
            };
        case 'FIND_FF_SEA_EXP_JOBORDER_FAILURE':
            return {
                ...state,
                loadingFFSeaExpJobOrderList: false,
                FFSeaExpJobOrderListError: action.payload,
            };
        //job order List//

        //currency List//
        case 'FIND_FF_SEA_EXP_CURRENCY_REQUEST':
            return {
                ...state,
                loadingFFSeaExpCurrencyList: true,
                FFSeaExpCurrencyList: [],
                FFSeaExpCurrencyListError: '',
            };
        case 'FIND_FF_SEA_EXP_CURRENCY_SUCCESS':
            return {
                ...state,
                loadingFFSeaExpCurrencyList: false,
                FFSeaExpCurrencyList: action.payload,
            };
        case 'FIND_FF_SEA_EXP_CURRENCY_FAILURE':
            return {
                ...state,
                loadingFFSeaExpCurrencyList: false,
                FFSeaExpCurrencyListError: action.payload,
            };
        //currency List//

        //final Quotation List//
        case 'FIND_FF_SEA_EXP_FINAL_QUOTATION_REQUEST':
            return {
                ...state,
                loadingFFSeaExpFinalQuotationList: true,
                FFSeaExpFinalQuotationList: [],
                FFSeaExpFinalQuotationListError: '',
            };
        case 'FIND_FF_SEA_EXP_FINAL_QUOTATION_SUCCESS':
            return {
                ...state,
                loadingFFSeaExpFinalQuotationList: false,
                FFSeaExpFinalQuotationList: action.payload,
            };
        case 'FIND_FF_SEA_EXP_FINAL_QUOTATION_FAILURE':
            return {
                ...state,
                loadingFFSeaExpFinalQuotationList: false,
                FFSeaExpFinalQuotationListError: action.payload,
            };
        //final Quotation List//

        //airport List//
        case 'FIND_FF_SEA_EXP_AIRPORT_REQUEST':
            return {
                ...state,
                loadingFFSeaExpAirportList: true,
                FFSeaExpAirportList: [],
                FFSeaExpAirportListError: '',
            };
        case 'FIND_FF_SEA_EXP_AIRPORT_SUCCESS':
            return {
                ...state,
                loadingFFSeaExpAirportList: false,
                FFSeaExpAirportList: action.payload,
            };
        case 'FIND_FF_SEA_EXP_AIRPORT_FAILURE':
            return {
                ...state,
                loadingFFSeaExpAirportList: false,
                FFSeaExpAirportListError: action.payload,
            };
        //airport List//

        //hawb detail//
        case 'FIND_FF_SEA_EXP_HAWB_DETAIL_REQUEST':
            return {
                ...state,
                loadingFFSeaExpHBLDetail: true,
                FFSeaExpHBLDetail: [],
                FFSeaExpHBLDetailError: '',
            };
        case 'FIND_FF_SEA_EXP_HAWB_DETAIL_SUCCESS':
            return {
                ...state,
                loadingFFSeaExpHBLDetail: false,
                FFSeaExpHBLDetail: action.payload,
            };
        case 'FIND_FF_SEA_EXP_HAWB_DETAIL_FAILURE':
            return {
                ...state,
                loadingFFSeaExpHBLDetail: false,
                FFSeaExpHBLDetailError: action.payload,
            };
        //hawb detail//

        //direct mawb detail//
        case 'FIND_FF_SEA_EXP_DIRECT_MAWB_DETAIL_REQUEST':
            return {
                ...state,
                loadingFFSeaExpDirectMAWBDetail: true,
                FFSeaExpDirectMAWBDetail: [],
                FFSeaExpDirectMAWBDetailError: '',
            };
        case 'FIND_FF_SEA_EXP_DIRECT_MAWB_DETAIL_SUCCESS':
            return {
                ...state,
                loadingFFSeaExpDirectMAWBDetail: false,
                FFSeaExpDirectMAWBDetail: action.payload,
            };
        case 'FIND_FF_SEA_EXP_DIRECT_MAWB_DETAIL_FAILURE':
            return {
                ...state,
                loadingFFSeaExpDirectMAWBDetail: false,
                FFSeaExpDirectMAWBDetailError: action.payload,
            };
        //direct mawb detail//

        //mawb detail//
        case 'FIND_FF_SEA_EXP_MAWB_DETAIL_REQUEST':
            return {
                ...state,
                loadingFFSeaExpMAWBDetail: true,
                FFSeaExpMAWBDetail: [],
                FFSeaExpMAWBDetailError: '',
            };
        case 'FIND_FF_SEA_EXP_MAWB_DETAIL_SUCCESS':
            return {
                ...state,
                loadingFFSeaExpMAWBDetail: false,
                FFSeaExpMAWBDetail: action.payload,
            };
        case 'FIND_FF_SEA_EXP_MAWB_DETAIL_FAILURE':
            return {
                ...state,
                loadingFFSeaExpMAWBDetail: false,
                FFSeaExpMAWBDetailError: action.payload,
            };
        //mawb detail//

        //organisation List//
        case 'FIND_FF_SEA_EXP_ORGANISATION_REQUEST':
            return {
                ...state,
                loadingFFSeaExpOrganisationList: true,
                FFSeaExpOrganisationList: [],
                FFSeaExpOrganisationListError: '',
            };
        case 'FIND_FF_SEA_EXP_ORGANISATION_SUCCESS':
            return {
                ...state,
                loadingFFSeaExpOrganisationList: false,
                FFSeaExpOrganisationList: action.payload,
            };
        case 'FIND_FF_SEA_EXP_ORGANISATION_FAILURE':
            return {
                ...state,
                loadingFFSeaExpOrganisationList: false,
                FFSeaExpOrganisationListError: action.payload,
            };
        //organisation List//

        //organisation shipper branch List//
        case 'FIND_FF_SEA_EXP_SHIPPER_BRANCH_REQUEST':
            return {
                ...state,
                loadingFFSeaExpShipperBranchList: true,
                FFSeaExpShipperBranchList: [],
                FFSeaExpShipperBranchListError: '',
            };
        case 'FIND_FF_SEA_EXP_SHIPPER_BRANCH_SUCCESS':
            return {
                ...state,
                loadingFFSeaExpShipperBranchList: false,
                FFSeaExpShipperBranchList: action.payload,
            };
        case 'FIND_FF_SEA_EXP_SHIPPER_BRANCH_FAILURE':
            return {
                ...state,
                loadingFFSeaExpShipperBranchList: false,
                FFSeaExpShipperBranchListError: action.payload,
            };
        //organisation shipper branch List//

        //organisation consignee branch List//
        case 'FIND_FF_SEA_EXP_CONSIGNEE_BRANCH_REQUEST':
            return {
                ...state,
                loadingFFSeaExpConsigneeBranchList: true,
                FFSeaExpConsigneeBranchList: [],
                FFSeaExpConsigneeBranchListError: '',
            };
        case 'FIND_FF_SEA_EXP_CONSIGNEE_BRANCH_SUCCESS':
            return {
                ...state,
                loadingFFSeaExpConsigneeBranchList: false,
                FFSeaExpConsigneeBranchList: action.payload,
            };
        case 'FIND_FF_SEA_EXP_CONSIGNEE_BRANCH_FAILURE':
            return {
                ...state,
                loadingFFSeaExpConsigneeBranchList: false,
                FFSeaExpConsigneeBranchListError: action.payload,
            };
        //organisation consignee branch List//

        //organisation shipper branch bank List//
        case 'FIND_FF_SEA_EXP_SHIPPER_BRANCH_BANK_REQUEST':
            return {
                ...state,
                loadingFFSeaExpShipperBranchBankList: true,
                FFSeaExpShipperBranchBankList: [],
                FFSeaExpShipperBranchBankListError: '',
            };
        case 'FIND_FF_SEA_EXP_SHIPPER_BRANCH_BANK_SUCCESS':
            return {
                ...state,
                loadingFFSeaExpShipperBranchBankList: false,
                FFSeaExpShipperBranchBankList: action.payload,
            };
        case 'FIND_FF_SEA_EXP_SHIPPER_BRANCH_BANK_FAILURE':
            return {
                ...state,
                loadingFFSeaExpShipperBranchBankList: false,
                FFSeaExpShipperBranchBankListError: action.payload,
            };
        //organisation shipper branch bank List//

        //organisation consignee branch bank List//
        case 'FIND_FF_SEA_EXP_CONSIGNEE_BRANCH_BANK_REQUEST':
            return {
                ...state,
                loadingFFSeaExpConsigneeBranchBankList: true,
                FFSeaExpConsigneeBranchBankList: [],
                FFSeaExpConsigneeBranchBankListError: '',
            };
        case 'FIND_FF_SEA_EXP_CONSIGNEE_BRANCH_BANK_SUCCESS':
            return {
                ...state,
                loadingFFSeaExpConsigneeBranchBankList: false,
                FFSeaExpConsigneeBranchBankList: action.payload,
            };
        case 'FIND_FF_SEA_EXP_CONSIGNEE_BRANCH_BANK_FAILURE':
            return {
                ...state,
                loadingFFSeaExpConsigneeBranchBankList: false,
                FFSeaExpConsigneeBranchBankListError: action.payload,
            };
        //organisation consignee branch bank List//

        //mawb-> unused hawb list//
        case 'FIND_FF_SEA_EXP_UNUSED_HAWB_REQUEST':
            return {
                ...state,
                loadingFFSeaExpUnusedHBLList: true,
                FFSeaExpUnusedHBLList: [],
                FFSeaExpUnusedHBLListError: '',
            };
        case 'FIND_FF_SEA_EXP_UNUSED_HAWB_SUCCESS':
            return {
                ...state,
                loadingFFSeaExpUnusedHBLList: false,
                FFSeaExpUnusedHBLList: action.payload,
            };
        case 'FIND_FF_SEA_EXP_UNUSED_HAWB_FAILURE':
            return {
                ...state,
                loadingFFSeaExpUnusedHBLList: false,
                FFSeaExpUnusedHBLListError: action.payload,
            };
        //mawb-> unused hawb list//

        //mawb-> unused hawb update list//
        case 'FIND_FF_SEA_EXP_UNUSED_HAWB_UPDATE_REQUEST':
            return {
                ...state,
                loadingFFSeaExpUnusedHAWBUpdateList: true,
                FFSeaExpUnusedHAWBUpdateList: [],
                FFSeaExpUnusedHAWBUpdateListError: '',
            };
        case 'FIND_FF_SEA_EXP_UNUSED_HAWB_UPDATE_SUCCESS':
            return {
                ...state,
                loadingFFSeaExpUnusedHAWBUpdateList: false,
                FFSeaExpUnusedHAWBUpdateList: action.payload,
            };
        case 'FIND_FF_SEA_EXP_UNUSED_HAWB_UPDATE_FAILURE':
            return {
                ...state,
                loadingFFSeaExpUnusedHAWBUpdateList: false,
                FFSeaExpUnusedHAWBUpdateListError: action.payload,
            };
        //mawb-> unused hawb update list//

        //mawb-> unused mawb in console manifest add form//
        case 'FIND_FF_SEA_EXP_CONSOLE_MANIFEST_MAWB_ADD_LIST_REQUEST':
            return {
                ...state,
                loadingFFSeaExpUnusedConsoleManifestMBLAddList: true,
                FFSeaExpUnusedConsoleManifestMBLAddList: [],
                FFSeaExpUnusedConsoleManifestMBLAddListError: '',
            };
        case 'FIND_FF_SEA_EXP_CONSOLE_MANIFEST_MAWB_ADD_LIST_SUCCESS':
            return {
                ...state,
                loadingFFSeaExpUnusedConsoleManifestMBLAddList: false,
                FFSeaExpUnusedConsoleManifestMBLAddList: action.payload,
            };
        case 'FIND_FF_SEA_EXP_CONSOLE_MANIFEST_MAWB_ADD_LIST_FAILURE':
            return {
                ...state,
                loadingFFSeaExpUnusedConsoleManifestMBLAddList: false,
                FFSeaExpUnusedConsoleManifestMBLAddListError: action.payload,
            };
        //mawb-> unused mawb in console manifest add form//

        //mawb-> calculate total freight//
        case 'FIND_CALCULATE_TOTAL_FREIGHT_REQUEST':
            return {
                ...state,
                loadingFFSeaExpTotalFreight: true,
                FFSeaExpTotalFreight: {},
                FFSeaExpTotalFreightError: '',
            };
        case 'FIND_CALCULATE_TOTAL_FREIGHT_SUCCESS':
            return {
                ...state,
                loadingFFSeaExpTotalFreight: false,
                FFSeaExpTotalFreight: action.payload,
            };
        case 'FIND_CALCULATE_TOTAL_FREIGHT_FAILURE':
            return {
                ...state,
                loadingFFSeaExpTotalFreight: false,
                FFSeaExpTotalFreightError: action.payload,
            };
        //mawb-> calculate total freight//

        //ff -> air -> exp -> console shipment list//
        case 'FIND_FF_SEA_EXP_CONSOLE_SHIPMENT_LIST_REQUEST':
            return {
                ...state,
                loadingFFSeaExpConsoleShipmentList: true,
                FFSeaExpConsoleShipmentList: [],
                FFSeaExpConsoleShipmentListError: '',
                FFSeaExpConsoleShipmentListCurrentPage: 0,
                FFSeaExpConsoleShipmentListTotalPage: 0,
                FFSeaExpConsoleShipmentListTotalData: 0,
                // FFSeaExpConsoleShipmentListCount: {},
            };
        case 'FIND_FF_SEA_EXP_CONSOLE_SHIPMENT_LIST_SUCCESS':
            return {
                ...state,
                loadingFFSeaExpConsoleShipmentList: false,
                FFSeaExpConsoleShipmentList: action.payload.data,
                FFSeaExpConsoleShipmentListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                FFSeaExpConsoleShipmentListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                FFSeaExpConsoleShipmentListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
                // FFSeaExpConsoleShipmentListCount: {},
            };
        case 'FIND_FF_SEA_EXP_CONSOLE_SHIPMENT_LIST_FAILURE':
            return {
                ...state,
                loadingFFSeaExpConsoleShipmentList: true,
                FFSeaExpConsoleShipmentListError: '',
                FFSeaExpConsoleShipmentListCurrentPage: 1,
                FFSeaExpConsoleShipmentListTotalPage: 0,
                FFSeaExpConsoleShipmentListTotalData: 0,
                // FFSeaExpConsoleShipmentListCount: {},
            };
        //ff -> air -> exp -> console shipment list//

        //ff -> air -> exp -> direct shipment list//
        case 'FIND_FF_SEA_EXP_DIRECT_SHIPMENT_LIST_REQUEST':
            return {
                ...state,
                loadingFFSeaExpDirectShipmentList: true,
                FFSeaExpDirectShipmentList: [],
                FFSeaExpDirectShipmentListError: '',
                FFSeaExpDirectShipmentListCurrentPage: 0,
                FFSeaExpDirectShipmentListTotalPage: 0,
                FFSeaExpDirectShipmentListTotalData: 0,
                // FFSeaExpDirectShipmentListCount: {},
            };
        case 'FIND_FF_SEA_EXP_DIRECT_SHIPMENT_LIST_SUCCESS':
            return {
                ...state,
                loadingFFSeaExpDirectShipmentList: false,
                FFSeaExpDirectShipmentList: action.payload.data,
                FFSeaExpDirectShipmentListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                FFSeaExpDirectShipmentListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                FFSeaExpDirectShipmentListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
                // FFSeaExpDirectShipmentListCount: {},
            };
        case 'FIND_FF_SEA_EXP_DIRECT_SHIPMENT_LIST_FAILURE':
            return {
                ...state,
                loadingFFSeaExpDirectShipmentList: true,
                FFSeaExpDirectShipmentListError: '',
                FFSeaExpDirectShipmentListCurrentPage: 1,
                FFSeaExpDirectShipmentListTotalPage: 0,
                FFSeaExpDirectShipmentListTotalData: 0,
                // FFSeaExpDirectShipmentListCount: {},
            };
        //ff -> air -> exp -> direct shipment list//

        //ff -> air -> exp -> console manifest list//
        case 'FIND_FF_SEA_EXP_CONSOLE_MANIFEST_LIST_REQUEST':
            return {
                ...state,
                loadingFFSeaExpConsoleManifestList: true,
                FFSeaExpConsoleManifestList: [],
                FFSeaExpConsoleManifestListError: '',
                FFSeaExpConsoleManifestListCurrentPage: 0,
                FFSeaExpConsoleManifestListTotalPage: 0,
                FFSeaExpConsoleManifestListTotalData: 0,
                // FFSeaExpConsoleManifestListCount: {},
            };
        case 'FIND_FF_SEA_EXP_CONSOLE_MANIFEST_LIST_SUCCESS':
            return {
                ...state,
                loadingFFSeaExpConsoleManifestList: false,
                FFSeaExpConsoleManifestList: action.payload.data,
                FFSeaExpConsoleManifestListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                FFSeaExpConsoleManifestListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                FFSeaExpConsoleManifestListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
                // FFSeaExpConsoleManifestListCount: {},
            };
        case 'FIND_FF_SEA_EXP_CONSOLE_MANIFEST_LIST_FAILURE':
            return {
                ...state,
                loadingFFSeaExpConsoleManifestList: true,
                FFSeaExpConsoleManifestListError: '',
                FFSeaExpConsoleManifestListCurrentPage: 1,
                FFSeaExpConsoleManifestListTotalPage: 0,
                FFSeaExpConsoleManifestListTotalData: 0,
                // FFSeaExpConsoleManifestListCount: {},
            };
        //ff -> air -> exp -> console manifest list//

        default:
            return state;
    }
}

export default FFSeaExpReducer;